export class IDropDownItem<T = number> {
  label: string;
  value: T;
  selected?: boolean;
}
